module.exports = __webpack_public_path__ + "vue-dist/img/exam-passed.caca4bd6.png";